export default {"src":"/_next/static/media/GiftGoldBanner.af0acfbd.gif","height":270,"width":294,"blurWidth":0,"blurHeight":0};